import { fill } from 'lodash';

const defaultProjects = fill(Array(25), {});

export default defaultProjects;
